import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => {
  return {
    responsivePieWrapper: {
      display: 'flex',
      marginBottom: theme.spacing(-2.5),
      width: '100%',
    },
    leftContainer: {
      display: 'flex',
    },
    rightContainer: {
      width: '50%',
      marginLeft: theme.spacing(7),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }
})
